import { z } from "zod/v4"

/**
 * Get the URL of the current environment.
 */
export const getUrl = (withTrailingSlash?: boolean, _url?: string) => {
  let url = _url
    ? _url
    : process.env.NEXT_PUBLIC_BASE_URL ||
      process.env.NEXT_PUBLIC_VERCEL_URL ||
      "http://localhost:3000"

  // Include `https://` if not localhost
  url = url.includes("http") ? url : `https://${url}`

  // Append/remove trailing `/` if not present
  if (withTrailingSlash) {
    url = url.charAt(url.length - 1) === "/" ? url : `${url}/`
  } else {
    url = url.charAt(url.length - 1) === "/" ? url.slice(0, -1) : url
  }

  return url
}

/**
 * Custom check that marks a value as required in production mode.
 * @param ctx - The context of the validation
 */
export const requiredInProduction = (ctx: z.core.ParsePayload<string | undefined>) => {
  // NOTE: Uses process.env directly to avoid circular dependency
  const isProduction =
    process.env.NEXT_PUBLIC_PRODUCTION_MODE === "true" ||
    process.env.NEXT_PUBLIC_PRODUCTION_MODE === "1"

  if (isProduction && !ctx.value) {
    ctx.issues.push({ code: "custom", input: ctx.value, message: "Required in production" })
  }
}

/**
 * Preprocess a string value into an array of strings.
 */
export const preprocessStringArray = z.preprocess(
  (val: unknown) => (typeof val === "string" ? val.split(",").map((s) => s.trim()) : []),
  z.array(z.string()),
)
